<template>
  <div class="main">
    <div class="main_tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="库存管理" name="first">
                <mixing-invent ref="inventm"></mixing-invent> 
            </el-tab-pane>
            <el-tab-pane label="入库记录" name="second">
                <mixing-income ref="incomem"></mixing-income>
            </el-tab-pane>
            <el-tab-pane label="消耗记录" name="third">
                <mixing-cost ref="costsm"></mixing-cost>
            </el-tab-pane>
            <el-tab-pane label="校正记录" name="four">
                <mixing-check ref="checkm"></mixing-check>
            </el-tab-pane>
            <!-- <el-tab-pane label="生产线料仓库存" name="five">
                <product-lineinvent ref="lineInvent"></product-lineinvent>
            </el-tab-pane>
            <el-tab-pane label="生产线当前物料库存情况" name="six">
                <product-linecurrent ref="lineCurrent"></product-linecurrent>
            </el-tab-pane>
            <el-tab-pane label="当日来料质检列表" name="seven">
                <today-quality ref="qualityT"></today-quality>
            </el-tab-pane>
            <el-tab-pane label="当日各料仓库存与消耗数据" name="eight">
                <today-cost ref="costT"></today-cost>
            </el-tab-pane> -->
        </el-tabs>
    </div>
  </div>
</template>
<script>
import MixingInvent from './components/MixingInvent.vue'//库存管理
import MixingIncome from './components/MixingIncome.vue'//入库记录
import MixingCost from './components/MixingCost.vue'//消耗记录
import MixingCheck from './components/MixingCheck.vue'//校正记录
// import ProductLineinvent from './components/ProductLineinvent.vue'//生产线料仓库存
// import ProductLinecurrent from './components/ProductLinecurrent.vue'//生产线当前物料库存情况
// import TodayQuality from './components/TodayQuality.vue'//当日来料质检列表
// import TodayCost from './components/TodayCost.vue'//当日各料仓库存与消耗数据
export default {
    components:{
        MixingInvent,
        MixingIncome,
        MixingCost,
        MixingCheck,
        // ProductLineinvent,
        // ProductLinecurrent,
        // TodayQuality,
        // TodayCost
    },
    data(){
        return{
            activeName:'first'
        }
    },
    mounted(){
        this.$refs.inventm.searchButtonInfo(true);
        this.$refs.inventm.getDictNames()
    },
    methods:{
        //切换界面
        handleClick(tab){
            switch(tab.name){
                case 'second':
                    this.$refs.incomem.searchButtonInfo(true);
                    this.$refs.incomem.getDictNames()
                    break;
                case 'third':
                    this.$refs.costsm.searchButtonInfo(true);
                    this.$refs.costsm.getDictNames()
                    this.$refs.costsm.getAllProjects()
                    break;
                case 'four':
                    this.$refs.checkm.searchButtonInfo(true);
                    this.$refs.checkm.getDictNames()
                    break;
                case 'five':
                    this.$refs.lineInvent.searchButtonInfo(true);
                    break;
                case 'six':
                    this.$refs.lineCurrent.searchButtonInfo(true);
                    break;
                case 'seven':
                    this.$refs.qualityT.searchButtonInfo(true);
                    break;
                case 'eight':
                    this.$refs.costT.searchButtonInfo(true);
                    break;
                default:
                    this.$refs.inventm.searchButtonInfo(true);
            }
        },
    }
}
</script>
<style scoped lang="scss">
@import'@/style/layout-main.scss';
/deep/ .el-tabs__content{
    position: static;
}

/deep/.main {
  background: none;
}
</style>